import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard/Home'
import Applications from '@/components/Applications/List'
import ApplicationCreate from '@/components/Applications/Create'
import ApplicationView from '@/components/Applications/View'
import Login from '@/components/Auth/Login'
import Logout from '@/components/Auth/Logout'

Vue.use(Router)


export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Dashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/applications',
            name: 'Applications',
            component: Applications,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/applications/create',
            name: 'ApplicationCreate',
            component: ApplicationCreate,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/applications/:id',
            name: 'ApplicationView',
            component: ApplicationView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/reports/',
            name: 'Reports',
            component: () => import(/* webpackChunkName: "reports" */ './components/Reports/index.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/help',
            name: 'help',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "help" */ './views/Help.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/guidelines-photo',
            name: 'guidelines-photo',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "guidelines-photo" */ './views/GuidelinesPhoto.vue'),
            meta: {
                requiresAuth: true
            }
        },
        // {
        //     path: '/about',
        //     name: 'about',
        //     // route level code-splitting
        //     // this generates a separate chunk (about.[hash].js) for this route
        //     // which is lazy-loaded when the route is visited.
        //     component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        // },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/logout',
            component: Logout
        }
    ]
})
